import { IonContent, IonPage, IonSpinner, IonText } from '@ionic/react';
type Props = {
  msg: string
}
const LoaderComponent: React.FC<Props> = ({ msg }) => {
  return (
    <IonPage>
      <IonContent className='ion-padding'>
        <div className="container">
          <img src='assets/icon/icon.png' draggable={false} alt='' />
          <div style={{ marginTop: 20 }}>
            <IonSpinner slot="start" name="lines-sharp" />
            <IonText color="primary"><h3>{msg}</h3></IonText>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default LoaderComponent;
